import React, { createContext, useContext, ReactNode } from 'react';
import { Toaster, useId, useToastController } from '@fluentui/react-components';

import { ToastContextType } from './types';

const ToastContext = createContext<ToastContextType>(undefined);

export const ToastProvider: React.FC<{ children: ReactNode }> = ({ children, ...props }) => {
  const toasterId = useId('toaster');
  const toastController = useToastController(toasterId);

  return (
    <ToastContext.Provider value={toastController}>
      {children}
      <Toaster {...props} toasterId={toasterId} position="top-end" />
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
